import { getPlatform } from "@angular/core";

export var apiColletions = { 

    // "user logins"

    "user_settings" : "/auth/setting",
    "user_register" : "/auth/register",
    "user_login" : "/auth/login",
    "get_user_profile" : "/users/profile",

    // "Assets details"
    "get_assets_list" : "/users/assets",
    "add_asset" : "/users/assets",
    "our_assets" : "/users/our-assets",
    

    // "Forgot password"

    "forgot_password_by_email" : "/auth/forgot-password-email" ,
    "reset_password_by_email" :  "/auth/reset-password-email" ,


    // "Payments apis"

    "get_card_key" : "/users/card-key",
    "add_card" : "/users/card" ,
    "get_card_list" : "/users/card" ,
    "select_card" : "/users/select-card",
    "delete_card" :"/users/card",
    "get_payment_key" :  "/users/payment-key",

     // language

     "get_language_list" : "/admin/language",

    //language
    getLanguageList: "/api/language/get_languages",
    strings: "/api/string/get_string",

    //admin settings
    getAdminSettings: "/api/company/company_details",

    //user auth api
    login: "/api/auth/signin",
    sendOtp: "/api/auth/send_otp",
    verifyOtp: "/api/auth/verify_otp",
    register: "/api/auth/signup",
    forgotPassword: "/api/auth/forget_password",
    userDetail : "/api/auth/get_entity_detail",
    updateEntityDetail: "/api/auth/update_entity_detail",

    // categories
    getCategories: "/api/categories/get_categories",
    categoryWiseProductList: "/api/products/category_with_products",

     // product
     getProduct: "/api/products/get_products",
     getProductDetails: "/api/products/get_product_by",

     // send message
     sendMessage: "/api/connects/send_message",

     //notify
     notifyProduct:"/api/notify/create_notify",

     //orders
     createOrder: "/api/orders/create_order",
     createRazorpayOrder: "/api/orders/create_razorpay_order",
     verifyRazorpayPayment: "/api/orders/verify_razorpay_payment",
     cancelRazorpayPayment: "/api/orders/cancel_razorpay_payment",
     getMyOrders: "/api/orders/get_my_orders",
     getOrderDetail: "/api/orders/get_order"

}
